import React, { Component } from 'react';
import './context-menu-view.scss';

export default class ContextMenu extends Component {
  render() {
    const style = {
      left: this.props.position.clientX,
    };

    let containerHeight = $('div.contentLeftBottom').outerHeight();
    let contextMenuContainerHeight = $('div.contextMenuContainer').outerHeight();
    if ((containerHeight - (this.props.position.clientY + contextMenuContainerHeight)) < 0) {
      style.top = this.props.position.clientY - contextMenuContainerHeight;
    } else {
      style.top = this.props.position.clientY;
    }

    return (
      <div className='contextMenuContainer' style={style}>
        {this.props.children}
      </div>);
  }
}

ContextMenu.propTypes = {
  position: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** app/components/context-menu/view/context-menu-view.js
 **/